import { render, staticRenderFns } from "./RatingField.vue?vue&type=template&id=1addf2ec&"
import script from "./RatingField.vue?vue&type=script&lang=js&"
export * from "./RatingField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports